/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![CollapseListIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA9UlEQVR4nO2VSwoCMQyGR28g+LyRaNNkFiXxcZfZ6pF0OSIqCuID9TZKZAafq1oXgj90k9D/SyhNougHVPC+CSQpEM+bzlWec3HcrwLxGkhOSZIU/QDIC0tyBuLtPQRAapZ4n+WW3h20290SEK/UyCIf47jX0Motyu4aI94Y0ylHn8iYTlmNMsN9XnkQ87edhDbPpYb64BZlFtz8r6uAZHp7xA8P8iR6lgZDAYAkfQH8FeyjAfE8+EdrOle5zSM5A8qh5Vw9iLn55rB7qDwb1xrT/RCkE4s8zivXJXMPziEWZeQPIB4qRJfM2+5QRpZk4A34CV0AkJ/Q5/2EIeEAAAAASUVORK5CYII=)
 */
export const CollapseListIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M7.3 2.3a1 1 0 0 1 1.4 0L12 5.58l3.3-3.3a1 1 0 1 1 1.4 1.42l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 0-1.42ZM2 12a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM8.7 21.7a1 1 0 0 1-1.4-1.4l4-4a1 1 0 0 1 1.4 0l4 4a1 1 0 0 1-1.4 1.4L12 18.42l-3.3 3.3Z"
        className={colorClass}
      />
    </svg>
  );
};
